import React from 'react';
import { formatDetailedTime, formatDate, getBrandingText } from '../templateUtils';

const NeonTemplate = ({
  language = 'zh',
  calculatedDays = 0,
  relationshipLabel = '在一起',
  detailedTime = null,
  anniversaryDate = null,
  anniversaryType = 'couple',
  quote = ''
}) => {
  const s = 3.375;
  const gradId = 'neon-tmpl-grad';

  return (
    <div
      style={{
        width: '1080px', height: '1350px',
        background: 'linear-gradient(180deg, #0d0221 0%, #1a0b2e 50%, #0d0221 100%)',
        overflow: 'hidden', position: 'relative',
        fontFamily: 'Arial, sans-serif', boxSizing: 'border-box'
      }}
    >
      {/* 霓虹光暈 */}
      <div style={{ position: 'absolute', top: '20%', left: '15%', width: `${120 * s}px`, height: `${120 * s}px`, borderRadius: '50%', background: 'radial-gradient(circle, rgba(255,0,150,0.4) 0%, transparent 70%)', filter: `blur(${35 * s}px)` }} />
      <div style={{ position: 'absolute', top: '40%', right: '10%', width: `${135 * s}px`, height: `${135 * s}px`, borderRadius: '50%', background: 'radial-gradient(circle, rgba(0,150,255,0.35) 0%, transparent 70%)', filter: `blur(${38 * s}px)` }} />
      <div style={{ position: 'absolute', bottom: '25%', left: '20%', width: `${105 * s}px`, height: `${105 * s}px`, borderRadius: '50%', background: 'radial-gradient(circle, rgba(150,0,255,0.3) 0%, transparent 70%)', filter: `blur(${30 * s}px)` }} />

      {/* 主內容區 */}
      <div style={{
        position: 'relative', zIndex: 10, height: '100%',
        display: 'flex', flexDirection: 'column',
        padding: `${24 * s}px ${20 * s}px ${20 * s}px ${20 * s}px`
      }}>

        {/* 頂部愛心圓圈 */}
        <div style={{ textAlign: 'center', marginBottom: `${14 * s}px` }}>
          <div style={{
            display: 'inline-block', padding: `${9 * s}px`,
            background: 'rgba(0,0,0,0.6)', borderRadius: '50%',
            border: `${2 * s}px solid #ff0096`,
            boxShadow: `0 0 ${20 * s}px #ff0096, 0 0 ${35 * s}px rgba(255,0,150,0.4)`
          }}>
            <svg xmlns="http://www.w3.org/2000/svg" width={`${48 * s}`} height={`${48 * s}`} viewBox="0 0 24 24">
              <defs>
                <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#ff0096" />
                  <stop offset="50%" stopColor="#9600ff" />
                  <stop offset="100%" stopColor="#0096ff" />
                </linearGradient>
              </defs>
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill={`url(#${gradId})`} />
            </svg>
          </div>
        </div>

        {/* 中間內容 */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
          <div style={{ fontSize: `${72 * s}px`, fontWeight: '800', color: '#ffffff', lineHeight: '1', marginBottom: `${8 * s}px`, fontFamily: 'Arial, sans-serif', letterSpacing: `${-2 * s}px`, textShadow: `0 0 ${8 * s}px #ff0096, 0 0 ${16 * s}px #ff0096, 0 0 ${24 * s}px #9600ff, 0 0 ${32 * s}px #0096ff` }}>
            {calculatedDays}
          </div>
          <div style={{ fontSize: `${16 * s}px`, fontWeight: '600', color: '#00ffff', marginBottom: `${16 * s}px`, textShadow: `0 0 ${10 * s}px #00ffff, 0 0 ${20 * s}px #00ffff` }}>
            {language === 'zh' ? `${relationshipLabel}的日子` : `days ${relationshipLabel}`}
          </div>
          {detailedTime && (
            <div style={{ fontSize: `${12 * s}px`, color: '#ffffff', fontWeight: '500', marginBottom: `${12 * s}px`, padding: `${6 * s}px ${14 * s}px`, background: 'rgba(0,0,0,0.7)', border: `${1 * s}px solid #9600ff`, borderRadius: `${20 * s}px`, display: 'inline-block', boxShadow: `0 0 ${15 * s}px rgba(150,0,255,0.6)` }}>
              {formatDetailedTime(detailedTime, language)}
            </div>
          )}
          {quote && (
            <div style={{ fontSize: `${10 * s}px`, color: '#ffb3ff', fontStyle: 'italic', lineHeight: '1.6', paddingLeft: `${16 * s}px`, paddingRight: `${16 * s}px`, textShadow: `0 0 ${6 * s}px rgba(255,0,150,0.5)` }}>
              "{quote}"
            </div>
          )}
        </div>

        {/* 底部信息 */}
        <div style={{
          textAlign: 'center', paddingTop: `${12 * s}px`, paddingBottom: `${10 * s}px`,
          background: 'rgba(0,0,0,0.6)', border: `${1 * s}px solid rgba(255,0,150,0.5)`,
          borderRadius: `${12 * s}px`, boxShadow: `0 0 ${15 * s}px rgba(255,0,150,0.3)`
        }}>
          {anniversaryDate && (
            <div style={{ fontSize: `${9 * s}px`, color: '#ffb3ff', marginBottom: `${6 * s}px`, textShadow: `0 0 ${6 * s}px rgba(255,0,150,0.5)` }}>
              {formatDate(anniversaryDate, language)}
            </div>
          )}
          <div style={{ fontSize: `${10 * s}px`, fontWeight: '700', color: '#ff0096', textTransform: 'uppercase', letterSpacing: `${1 * s}px`, marginBottom: `${4 * s}px`, textShadow: `0 0 ${12 * s}px #ff0096, 0 0 ${24 * s}px #ff0096` }}>
            {getBrandingText(anniversaryType, language)}
          </div>
          <div style={{ fontSize: `${8 * s}px`, color: '#00ffff', textShadow: `0 0 ${6 * s}px #00ffff` }}>
            lovedays.homy.hk
          </div>
        </div>
      </div>
    </div>
  );
};

export default NeonTemplate;